import React from 'react';
import styles from './index.module.scss';
import ArticleMainBlock from '../article_components/ArticleMainBlock';
import ArticleContentBlock from '../article_components/ArticleContentBlock';

/**
 * Страница статьи для tab_blank (blank_template === 'article_blank').
 * Рендерит контент только через article_components (ArticleMainBlock, ArticleContentBlock).
 * Выводит все блоки, включая блок с индексом 0.
 */
const ArticleBlank = ({ contentData, path_to_folder }) => {
  const renderBlock = (el) => {
    if (el.boock_tag === 'main_block' || el.block_tag === 'main_block') {
      return <ArticleMainBlock blockData={el} path_to_folder={path_to_folder} />;
    }
    if (el.boock_tag === 'content_block' || el.block_tag === 'content_block') {
      return <ArticleContentBlock blockData={el} path_to_folder={path_to_folder} />;
    }
    return null;
  };

  if (!contentData || !Array.isArray(contentData)) {
    return null;
  }

  const blocksToRender = contentData
    .map((block, index) => {
      const renderedBlock = renderBlock(block);
      return renderedBlock ? (
        <div key={index} className={styles.blockWrapper}>
          {renderedBlock}
        </div>
      ) : null;
    })
    .filter((block) => block !== null);

  if (blocksToRender.length === 0) {
    return null;
  }

  return (
    <div className={styles.articleBlank}>
      <div className={styles.blocksContainer}>{blocksToRender}</div>
    </div>
  );
};

export default ArticleBlank;
